import { IsNotEmpty, IsNumber, IsOptional, IsString } from 'class-validator';

import BaseIvrNode, { EMPTY_NEXT_ID_MESSAGE } from './baseIvrNode';

enum InputType {
  DTMF = 'DTMF',
  DTMF_SPEECH = 'DTMF_SPEECH',
  SPEECH = 'SPEECH',
}

export default class InputNode extends BaseIvrNode {
  @IsString()
  type: InputType;

  @IsOptional()
  @IsNumber()
  numDigits: number;

  @IsNumber()
  timeout: number;

  @IsString()
  @IsOptional()
  hints: string;

  @IsString()
  @IsNotEmpty({ message: EMPTY_NEXT_ID_MESSAGE })
  nextId?: string;
}
